export interface ComponentBaseProps {
	readonly disabled?: boolean;
}

export default abstract class ComponentBase<TProps extends ComponentBaseProps> {
	protected containerInternal: JQuery;
	protected props: TProps;

	constructor(props: TProps) {
		this.props = props;
	}

	public get disabled(): boolean {
		return this.props.disabled;
	}

	public get container(): JQuery {
		return this.containerInternal;
	}

	public render(): JQuery {
		this.container?.remove();

		if (this.props.disabled) {
			return null;
		}

		this.containerInternal = this.renderInternal();
		return this.containerInternal;
	}

	protected abstract renderInternal(): JQuery;
}
